export default "__VITE_ASSET__DNjSCEhZ__"